import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesBulkDeleteAsyncSlice } from './delete';
import { coreInitiativesBulkPatchAsyncSlice } from './patch';

export const coreInitiativesBulkReducers = combineReducers({
	delete: coreInitiativesBulkDeleteAsyncSlice.asyncReducers,
	patch: coreInitiativesBulkPatchAsyncSlice.asyncReducers
});

export const coreInitiativesBulkWatchers = combineAllWatchers([
	coreInitiativesBulkDeleteAsyncSlice.asyncWatchers,
	coreInitiativesBulkPatchAsyncSlice.asyncWatchers
]);
